import styled from 'styled-components';
import { colors, typography, spacing, shadows, borderRadius, breakpoints } from '../../styles/theme';

export const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  background: ${props => props.$background || colors.gradients.hero};
  padding: ${spacing['3xl']} ${spacing.lg} ${spacing['2xl']};
  color: ${colors.neutral.white};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing.xl} ${spacing.md} ${spacing.xl};
  }
`;

export const HeroContent = styled.div`
  max-width: 1100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  align-items: center;
  justify-content: center;
`;

export const BadgeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.xs};
`;

export const Badge = styled.span`
  background: ${props => props.$variant === 'secondary' ? 'rgba(255, 255, 255, 0.2)' : colors.primary.orange};
  color: ${colors.neutral.white};
  font-size: ${typography.fontSize.xs};
  font-weight: ${typography.fontWeight.semibold};
  padding: ${spacing.xs} ${spacing.sm};
  border-radius: ${borderRadius.full};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
`;

export const Title = styled.h1`
  font-size: ${typography.fontSize['4xl']};
  font-weight: ${typography.fontWeight.extrabold};
  line-height: ${typography.lineHeight.tight};
  margin: 0;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize['3xl']};
  }
`;

export const Subtitle = styled.p`
  font-size: ${typography.fontSize.lg};
  opacity: 0.95;
  line-height: ${typography.lineHeight.relaxed};
  margin: 0;
  max-width: 540px;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.base};
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.md};
  margin-top: ${spacing.sm};

  @media (max-width: ${breakpoints.md}) {
    justify-content: center;
  }
`;

export const ActionButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs};
  padding: 0.875rem 1.75rem;
  border-radius: ${borderRadius.xl};
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.base};
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
  box-shadow: ${shadows.md};

  ${props => props.$variant === 'primary' ? `
    background: ${colors.primary.orange};
    color: ${colors.neutral.white};

    &:hover {
      background: ${colors.primary.orangeLight};
      transform: translateY(-2px);
      box-shadow: ${shadows.orangeHover};
    }
  ` : props.$variant === 'secondary' ? `
    background: ${colors.neutral.white};
    color: ${colors.primary.teal};

    &:hover {
      background: ${colors.neutral.gray100};
      transform: translateY(-2px);
      box-shadow: ${shadows.lg};
    }
  ` : `
    background: rgba(255, 255, 255, 0.15);
    color: ${colors.neutral.white};
    border: 1.5px solid rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(6px);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-2px);
    }
  `}
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 340px;
  object-fit: contain;
  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.03);
  }
`;
